var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5327,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2313 11.0512C22.4642 11.2911 22.6296 11.5881 22.7108 11.9124C22.9277 13.1138 23.033 14.3328 23.0253 15.5536C23.0296 16.7563 22.9244 17.9568 22.7108 19.1403C22.6296 19.4645 22.4642 19.7616 22.2313 20.0015C21.9985 20.2414 21.7064 20.4156 21.3845 20.5066C20.2087 20.8209 15.5052 20.8209 15.5052 20.8209C15.5052 20.8209 10.8017 20.8209 9.62588 20.5066C9.31059 20.4204 9.02289 20.2544 8.79056 20.0246C8.55823 19.7949 8.38914 19.5091 8.29961 19.1949C8.08273 17.9935 7.97746 16.7745 7.98513 15.5536C7.97914 14.3419 8.08441 13.1322 8.29961 11.9397C8.38082 11.6155 8.54621 11.3184 8.77908 11.0785C9.01195 10.8386 9.30405 10.6643 9.62588 10.5734C10.8017 10.2591 15.5052 10.2591 15.5052 10.2591C15.5052 10.2591 20.2087 10.2591 21.3845 10.546C21.7064 10.637 21.9985 10.8113 22.2313 11.0512ZM17.8972 15.5537L13.9662 17.7876V13.3197L17.8972 15.5537Z",
    fill: "#052142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube_logo.8429d324b708e91e7693b3f3767947d9.svg";
export { ForwardRef as ReactComponent };